import { Home, Request, QuickRequest, Worklist, Plants, Setups } from '../components/pages';

/**
 * @type {import('react').ComponentProps<typeof import('@pella/react-layout').Layout>['routes']}
 */
export const routes = [
  {
    path: '/',
    title: 'Home',
    icon: 'home',
    element: <Home />,
  },
  {
    path: 'request',
    title: 'New Request',
    icon: 'assignment_add',
    element: <Request />,
  },
  {
    path: 'worklist',
    title: 'Worklist',
    icon: 'assignment',
    element: <Worklist />,
  },
  {
    path: 'quick-request',
    title: 'Quick Request',
    icon: 'auto_awesome',
    element: <QuickRequest />,
  },
  {
    path: 'plants',
    title: 'Plants',
    icon: 'factory',
    element: <Plants />,
    roles: ['IT_ADMIN_V2'],
  },
  {
    path: 'setups',
    title: 'Setups',
    icon: 'settings',
    element: <Setups />,
    roles: ['SETUPS_V2', 'IT_ADMIN_V2'],
  },
];
